var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m19.5 12h-15m0 0 6.75 6.75m-6.75-6.75 6.75-6.75","stroke":"#d1d5db","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

ArrowLeft.defaultProps = {"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
